import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { Remarkable } from "remarkable";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";

var md = new Remarkable();

// markup
const IndexPage = () => (
  <StaticQuery query={blogData} render={(data) => {
    // console.log(data)
    const queryData = data.allMarkdownRemark.edges[0].node.frontmatter
    // console.log(queryData)
    
    return (
      <Container>
          <div className="justify-content-md-center">
            <h1> Blogs </h1>
          </div>
          
          {data.allMarkdownRemark.edges.map((tag, ind) => (
            <Row key={ind}>
              <Col lg={12} md={12} sm={12} xs={12}>
                <h1>{tag.node.frontmatter.title}</h1>
                <p>{tag.node.frontmatter.date}</p>
                <div dangerouslySetInnerHTML={{__html: md.render(queryData.description).substring(0, 250)}}></div>
              </Col>
            </Row>
          ))}
      </Container>
    )
  }}/>
)

const blogData = graphql`
query blog {
  allMarkdownRemark(filter: { fileAbsolutePath: { regex: "posts/blog/" } }) {
    edges {
      node {
        id
        frontmatter {
          title
          date
          description
          image
        }
      }
    }
  }
}`

export default IndexPage;
